import { isEmpty } from "lodash";
import { ENVIRONMENT, projectEstimateTabs, projectsManagementTabs } from "../../utils/properties";
import { checkRoles, decryptData, encryptData } from "../../utils/utilities";

const SET_USER_INFO = "SET_USER_INFO";
const SET_USER_MASTER = "SET_USER_MASTER";
const USER_LOGOUT = "USER_LOGOUT";
const SET_USERNAME = "SET_USERNAME";
const INIT_USERNAME = "INIT_USERNAME";

export function setUserInfo(value) {
  return {
    type: SET_USER_INFO,
    payload: {
      userInfo: value,
    },
  };
}

export function setUserMaster(value) {
  return {
    type: SET_USER_MASTER,
    payload: {
      userMaster: value,
    },
  };
}

export function userLogout() {
  return {
    type: USER_LOGOUT,
    payload: {},
  };
}

export function setUsername(value) {
  return {
    type: SET_USERNAME,
    payload: {
      username: value,
    },
  };
}

export function initUsername() {
  return {
    type: INIT_USERNAME,
    payload: {},
  };
}

const INIT_STATE = {
  userInfo: {},
  userMaster: {},
};

export default function userInfoDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  const localUserInfo = decryptData(localStorage.getItem("userInfo"));
  const localUserMaster = decryptData(localStorage.getItem("userMaster"));
  switch (action.type) {
    case SET_USER_INFO:
      newState.userInfo = action.payload.userInfo;
      newState.userInfo.canEditCostEstimation = checkRoles(
        action.payload.userInfo.roles,
        projectEstimateTabs["costEstimation"].edit
      );
      newState.userInfo.canEditKickOff = checkRoles(action.payload.userInfo.roles, projectEstimateTabs["kickOff"].edit);
      newState.userInfo.canEditProjectForm = checkRoles(
        action.payload.userInfo.roles,
        projectsManagementTabs["ProjectForm"].edit
      );
      newState.userInfo.canEditPlanning = checkRoles(
        action.payload.userInfo.roles,
        projectsManagementTabs["Planning"].edit
      );
      newState.userInfo.canEditAdjPlanning = checkRoles(
        action.payload.userInfo.roles,
        projectsManagementTabs["adjPlanning"].edit
      );
      newState.userInfo.canEditRiskAnalysis = checkRoles(
        action.payload.userInfo.roles,
        projectsManagementTabs["RiskAnalysis"].edit
      );
      newState.userInfo.canEditDashboard = checkRoles(
        action.payload.userInfo.roles,
        projectsManagementTabs["Dashboard"].edit
      );
      localStorage.setItem("userInfo", encryptData(action.payload.userInfo));
      break;
    case SET_USER_MASTER:
      newState.userMaster = action.payload.userMaster;
      localStorage.setItem("userMaster", encryptData(action.payload.userMaster));
      break;
    case USER_LOGOUT:
      newState.userInfo = {};
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userMaster");
      break;
    case SET_USERNAME:
      newState.username = action.payload.username;
      localStorage.setItem("username", JSON.stringify(action.payload.username));
      break;
    case INIT_USERNAME:
      newState.username = "";
      localStorage.removeItem("username");
      break;
    default:
      /*
        If I'm here, the user change manually route or refresh page and now the state is empty.
        So I check if I'm not in login and is logged in by localstorage. If I haven't localstorage and I have empty state, I redirect to login 
      */
      newState = state;
      if (isEmpty(newState.userInfo) && !isEmpty(localUserInfo)) {
        newState.userInfo = localUserInfo;
        newState.userMaster = localUserMaster;
      } else if (
        !/login$/.test(window.location.href) &&
        !/recovery-password$/.test(window.location.href) &&
        !/reset-password$/.test(window.location.href) &&
        isEmpty(newState.userInfo) &&
        isEmpty(localUserInfo)
      ) {
        window.location.href = `${ENVIRONMENT.BASE_URL}login`;
      }
      break;
  }
  return newState;
}
